import { AlertErrorCircle } from '@/assets/icons'
import { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'

export default function NewChatSkillsError() {
  const skillInitError = useAppSelector((state: RootState) => state.skillsState.skillInitError)

  if (!skillInitError) {
    return null
  }

  return (
    <div className={'flex gap-x-2 text-red-800 justify-center w-full text-sm mb-4'}>
      <AlertErrorCircle className="w-5 h-5" />
      <div>Error initializing skill. Please try again.</div>
    </div>
  )
}
